import * as angular from "angular";
import { IntegrationErrorsService } from "../services/integration-errors.service";

export class IntegrationErrorsDataProvider {
    public errors: object[];
    public getErrorsPromise: any;
    private integrationName: string;

    private $q: any;
    private service: IntegrationErrorsService;

    constructor($q: any, IntegrationErrorsService: IntegrationErrorsService) {
        this.$q = $q;
        this.errors = null;
        this.getErrorsPromise = null;
        this.service = IntegrationErrorsService;
        this.integrationName = null;
    }

    setName(integrationName: string): void {
        this.integrationName = integrationName;
    }

    getAllErrors(forceCall: boolean = false): Promise<any> {
        const deferred = this.$q.defer();
        if (this.errors !== null && !forceCall) {
            deferred.resolve(this.errors);
            this.getErrorsPromise = deferred.promise;
            return this.getErrorsPromise;
        } else if (this.getErrorsPromise && !forceCall) {
            return this.getErrorsPromise;
        } else {
            this.service.all(this.integrationName).then(
                (response: object) => {
                    const json = response["data"];
                    this.errors = json.data;
                    deferred.resolve(this.errors);
                },
                (error) => {
                    this.errors = null;
                    deferred.reject(error);
                }
            );
            this.getErrorsPromise = deferred.promise;
            return this.getErrorsPromise;
        }
    }

    push(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.push(this.integrationName).then(
            (response) => {
                const json = response["data"];
                deferred.resolve(json);
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    processSocketUpdate(socketData): void {
        if (this.integrationName == socketData.integration) {
            this.getAllErrors(true);
        }
    }
}

angular
    .module("vcDataProvider")
    .service("IntegrationErrorsDataProvider", IntegrationErrorsDataProvider);
